var map = {
	"./shift/decorators/GlobalDecorator": [
		37,
		37
	],
	"./shift/decorators/GlobalDecorator.js": [
		37,
		37
	],
	"./shift/decorators/LinkLocationDecorator": [
		977,
		977
	],
	"./shift/decorators/LinkLocationDecorator.js": [
		977,
		977
	],
	"./shift/decorators/LinkTypeDecorator": [
		4586,
		4586
	],
	"./shift/decorators/LinkTypeDecorator.js": [
		4586,
		4586
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8563;
module.exports = webpackAsyncContext;